import styled from "styled-components";

import { MedicalInstitutionMember, MemberContract } from "../../types";
import { Typography } from "../atoms/Typography";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";
import { ReissueSecretCodeButton } from "./ReissueSecretCodeButton";
import { PdtIcon } from "../atoms/PdtIcon";
import { USER_ROLE, UserRole } from "../../utils";

/**
 * MedicalInstitutionMemberList Component
 */
type MedicalInstitutionMemberListProps = {
  medicalInstitutionMembers: MedicalInstitutionMember[];
  refetchMedicalInstitutionMembers: () => void;
  userRole?: UserRole;
};

const ReissueSecretCodeButtonWrapper = styled.div`
  width: 200px;
  height: 30px;
  margin-left: auto;
`;

const StyledMemberContractList = styled.ul`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const MemberContractList = ({ contracts }: { contracts: MemberContract[] }) => (
  <StyledMemberContractList>
    {contracts.map((contract) => (
      <li key={contract.id}>
        <PdtIcon
          src={contract.pdt.iconPath}
          size={40}
          alt={contract.pdt.name}
        />
      </li>
    ))}
  </StyledMemberContractList>
);

export function MedicalInstitutionMemberList({
  medicalInstitutionMembers,
  refetchMedicalInstitutionMembers,
  userRole,
}: MedicalInstitutionMemberListProps) {
  const flexRatio = [1, 1, 1, 3, 1, 2];

  const headerTitles = ["名前", "職位", "権限", "担当製品", "ステータス", ""];

  const items = medicalInstitutionMembers.map(
    (medicalInstitutionMember: MedicalInstitutionMember, index: number) => {
      const { contracts = [] } = medicalInstitutionMember;

      return (
        <DataListRow flexRatio={flexRatio} key={index}>
          <DataListBodyItem>
            <Typography size={2} withEllipsis={true}>
              {medicalInstitutionMember.name}
            </Typography>
          </DataListBodyItem>
          <DataListBodyItem>
            <Typography size={2} withEllipsis={true}>
              {medicalInstitutionMember.position.join("、")}
            </Typography>
          </DataListBodyItem>
          <DataListBodyItem>
            <Typography size={2} withEllipsis={true}>
              {medicalInstitutionMember.role.join("、")}
            </Typography>
          </DataListBodyItem>
          <DataListBodyItem>
            <MemberContractList contracts={contracts} />
          </DataListBodyItem>
          <DataListBodyItem>
            <Typography size={2}>{medicalInstitutionMember.status}</Typography>
          </DataListBodyItem>
          <DataListBodyItem>
            {userRole === USER_ROLE.CS_USER && (
              <ReissueSecretCodeButtonWrapper>
                <ReissueSecretCodeButton
                  medicalInstitutionMemberId={medicalInstitutionMember.id}
                  medicalInstitutionMemberName={medicalInstitutionMember.name}
                  medicalInstitutionMemberStatus={
                    medicalInstitutionMember.status
                  }
                  refetchMedicalInstitutionMembers={
                    refetchMedicalInstitutionMembers
                  }
                />
              </ReissueSecretCodeButtonWrapper>
            )}
          </DataListBodyItem>
        </DataListRow>
      );
    },
  );

  return (
    <DataTable>
      <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
      <DataListBody rows={items} />
    </DataTable>
  );
}
